"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveSelectedMemberProfileAndContactStarted = exports.setSelectedMember = exports.submitCreateMemberFormStarted = exports.deleteInviteStarted = exports.resendInviteStarted = exports.deleteHouseholdPersonStarted = exports.submitHouseholdFormStarted = exports.householdError = exports.receiveHouseholds = exports.receiveHouseholdStarted = exports.SAVE_SELECTED_MEMBER_PROFILE_AND_CONTACT_STARTED = exports.SET_SELECTED_MEMBER = exports.SUBMIT_CREATE_MEMBER_FORM_STARTED = exports.DELETE_INVITE_STARTED = exports.RESENT_INVITE_STARTED = exports.DELETE_HOUSEHOLD_USER_STARTED = exports.SUBMIT_HOUSEHOLD_FORM_STARTED = exports.ACCEPT_HOUSEHOLD_INVITE_STARTED = exports.HOUSEHOLDS_ERROR = exports.RECEIVE_HOUSEHOLDS = exports.RECEIVE_HOUSEHOLDS_STARTED = void 0;
exports.default = reducer;
exports.loadHouseholds = loadHouseholds;
exports.acceptHouseholdInviteToken = acceptHouseholdInviteToken;
exports.submitHouseholdForm = submitHouseholdForm;
exports.deleteHouseholdPerson = deleteHouseholdPerson;
exports.resendInvite = resendInvite;
exports.deleteInvite = deleteInvite;
exports.saveSelectedMemberProfileAndContact = saveSelectedMemberProfileAndContact;
exports.submitCreateMemberForm = submitCreateMemberForm;
const validations_common_1 = require("components/form/validations-common");
/* eslint-disable @typescript-eslint/ban-ts-comment */
const api_utils_1 = require("core/api-utils");
const lodash_1 = require("lodash");
const redux_form_1 = require("redux-form");
const object_utils_1 = require("utils/object-utils");
// ducks
const app_1 = require("./app");
const contact_infos_1 = require("./contact-infos");
const api_1 = require("core/api");
const app_2 = require("selectors/app");
// selectors
const contact_infos_2 = require("selectors/contact-infos");
const households_1 = require("selectors/households");
const profile_1 = require("selectors/profile");
// Actions
exports.RECEIVE_HOUSEHOLDS_STARTED = 'RECEIVE_HOUSEHOLDS_STARTED';
exports.RECEIVE_HOUSEHOLDS = 'RECEIVE_HOUSEHOLDS';
exports.HOUSEHOLDS_ERROR = 'HOUSEHOLDS_ERROR';
exports.ACCEPT_HOUSEHOLD_INVITE_STARTED = 'ACCEPT_HOUSEHOLD_INVITE_STARTED';
exports.SUBMIT_HOUSEHOLD_FORM_STARTED = 'SUBMIT_HOUSEHOLD_FORM_STARTED';
exports.DELETE_HOUSEHOLD_USER_STARTED = 'DELETE_HOUSEHOLD_USER_STARTED';
exports.RESENT_INVITE_STARTED = 'RESENT_INVITE_STARTED';
exports.DELETE_INVITE_STARTED = 'DELETE_INVITE_STARTED';
exports.SUBMIT_CREATE_MEMBER_FORM_STARTED = 'SUBMIT_CREATE_MEMBER_FORM_STARTED';
exports.SET_SELECTED_MEMBER = 'SET_SELECTED_MEMBER';
exports.SAVE_SELECTED_MEMBER_PROFILE_AND_CONTACT_STARTED = 'SAVE_SELECTED_MEMBER_PROFILE_AND_CONTACT_STARTED';
// Reducer
const initialState = {
    households: [],
    householdsLoaded: false,
    selectedMember: null,
};
function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case 'RECEIVE_HOUSEHOLDS_STARTED':
            return {
                ...state,
            };
        case 'RECEIVE_HOUSEHOLDS':
            return {
                ...state,
                householdsLoaded: true,
                households: action.data,
            };
        case 'HOUSEHOLDS_ERROR':
            return {
                ...state,
                householdsLoaded: false,
                error: action.error,
            };
        case 'SUBMIT_HOUSEHOLD_FORM_STARTED':
            return {
                ...state,
            };
        case 'DELETE_HOUSEHOLD_USER_STARTED':
            return {
                ...state,
            };
        case 'RESENT_INVITE_STARTED':
            return {
                ...state,
            };
        case 'DELETE_INVITE_STARTED':
            return {
                ...state,
            };
        case 'SUBMIT_CREATE_MEMBER_FORM_STARTED':
            return {
                ...state,
            };
        case 'SET_SELECTED_MEMBER':
            return {
                ...state,
                selectedMember: action.data,
            };
        default:
            return state;
    }
}
// Action Creators
const receiveHouseholdStarted = () => {
    return { type: exports.RECEIVE_HOUSEHOLDS_STARTED };
};
exports.receiveHouseholdStarted = receiveHouseholdStarted;
const receiveHouseholds = (data) => {
    return { type: exports.RECEIVE_HOUSEHOLDS, data };
};
exports.receiveHouseholds = receiveHouseholds;
const householdError = (data) => {
    return { type: exports.HOUSEHOLDS_ERROR, data };
};
exports.householdError = householdError;
const submitHouseholdFormStarted = () => {
    return { type: exports.SUBMIT_HOUSEHOLD_FORM_STARTED };
};
exports.submitHouseholdFormStarted = submitHouseholdFormStarted;
const deleteHouseholdPersonStarted = () => {
    return { type: exports.DELETE_HOUSEHOLD_USER_STARTED };
};
exports.deleteHouseholdPersonStarted = deleteHouseholdPersonStarted;
const resendInviteStarted = () => {
    return { type: exports.RESENT_INVITE_STARTED };
};
exports.resendInviteStarted = resendInviteStarted;
const deleteInviteStarted = () => {
    return { type: exports.DELETE_INVITE_STARTED };
};
exports.deleteInviteStarted = deleteInviteStarted;
const submitCreateMemberFormStarted = () => {
    return { type: exports.SUBMIT_CREATE_MEMBER_FORM_STARTED };
};
exports.submitCreateMemberFormStarted = submitCreateMemberFormStarted;
const setSelectedMember = (data) => {
    return { type: exports.SET_SELECTED_MEMBER, data };
};
exports.setSelectedMember = setSelectedMember;
const saveSelectedMemberProfileAndContactStarted = () => {
    return { type: exports.SAVE_SELECTED_MEMBER_PROFILE_AND_CONTACT_STARTED };
};
exports.saveSelectedMemberProfileAndContactStarted = saveSelectedMemberProfileAndContactStarted;
// services
function loadHouseholds() {
    return (dispatch) => {
        dispatch((0, exports.receiveHouseholdStarted)());
        return api_1.HouseholdsService.getHouseholds()
            .then((data) => {
            dispatch((0, exports.receiveHouseholds)(data));
        })
            .catch((error) => {
            dispatch((0, exports.householdError)(error));
        });
    };
}
function acceptHouseholdInviteToken(token) {
    return (dispatch) => {
        return (api_1.HouseholdsService.updateInvite(token, { status: 'accepted' })
            // @ts-ignore
            .then((data) => {
            if (!data || !data.id) {
                dispatch((0, app_1.appFeedbackMessageError)('Invalid household invitation'));
            }
            else {
                dispatch((0, app_1.appFeedbackMessageSuccess)('Household invitation accepted'));
            }
        })
            .catch((_error) => {
            dispatch((0, app_1.appFeedbackMessageError)('Failed to accept household invitation'));
        }));
    };
}
function submitHouseholdForm(household) {
    // throw an error before submitting on the form, but doing it here so the button
    // can be clicked first?!
    if ((0, lodash_1.isEmpty)(household.name)) {
        const nameValidationError = {
            name: ['You must enter a name for the household'],
        };
        throw new redux_form_1.SubmissionError((0, api_utils_1.formatApiErrors)(nameValidationError));
    }
    return (dispatch) => {
        dispatch((0, exports.submitHouseholdFormStarted)());
        if (household.id) {
            return api_1.HouseholdsService.updateHousehold(household.id, {
                name: household.name,
            })
                .then((_res) => {
                return dispatch(loadHouseholds());
            })
                .catch((errorRes) => {
                const errorText = 'Failed to update your household';
                dispatch((0, app_1.appFeedbackMessageError)(errorText));
                if (errorRes.validationErrors) {
                    throw new redux_form_1.SubmissionError((0, api_utils_1.formatApiErrors)(errorRes.validationErrors));
                }
                return errorRes;
            });
        }
        else {
            return api_1.HouseholdsService.createHousehold(household)
                .then((_res) => {
                return dispatch(loadHouseholds());
            })
                .catch((errorRes) => {
                const errorText = 'Failed to update your household';
                dispatch((0, app_1.appFeedbackMessageError)(errorText));
                if (errorRes.validationErrors) {
                    throw new redux_form_1.SubmissionError((0, api_utils_1.formatApiErrors)(errorRes.validationErrors));
                }
                return errorRes;
            });
        }
    };
}
function deleteHouseholdPerson(household, member, isCurrentUser = false) {
    let successText = 'Household member deleted';
    let errorText = 'Failed to deleted household member';
    if (isCurrentUser) {
        successText = `You've been removed from the ${household.name} household`;
        errorText = `Failed to remove you from the ${household.name} household`;
    }
    return (dispatch) => {
        dispatch((0, exports.deleteHouseholdPersonStarted)());
        (0, households_1.tempDeleteHouseholdPerson)(household, member);
        return api_1.HouseholdsService.deleteHouseholdPerson(member.householdId, member.id)
            .then((_res) => {
            if (isCurrentUser) {
                dispatch(loadHouseholds());
            }
            return dispatch((0, app_1.appFeedbackMessageSuccess)(successText));
        })
            .catch((errorRes) => {
            dispatch((0, app_1.appFeedbackMessageError)(errorText));
            (0, households_1.addHouseholdPerson)(household, member);
            if (errorRes.validationErrors) {
                throw new redux_form_1.SubmissionError((0, api_utils_1.formatApiErrors)(errorRes.validationErrors));
            }
            return errorRes;
        });
    };
}
function resendInvite(householdPerson) {
    const successText = 'Invitation resent';
    const errorText = 'Failed to resend invitation';
    return (dispatch) => {
        dispatch((0, exports.resendInviteStarted)());
        return api_1.HouseholdsService.resendInvite(householdPerson.householdId, householdPerson.id)
            .then((_data) => {
            dispatch((0, app_1.appFeedbackMessageSuccess)(successText));
        })
            .catch(() => {
            dispatch((0, app_1.appFeedbackMessageError)(errorText));
        });
    };
}
function deleteInvite(householdPerson) {
    const successText = 'Invitation deleted';
    const errorText = 'Failed to delete invitation';
    const oldStatus = householdPerson.inviteStatus;
    return (dispatch) => {
        dispatch((0, exports.resendInviteStarted)());
        householdPerson.inviteStatus = 'deleted';
        return api_1.HouseholdsService.deleteInvite(householdPerson.householdId, householdPerson.id)
            .then((res) => {
            if (res.error) {
                throw res.error;
            }
            dispatch((0, app_1.appFeedbackMessageSuccess)(successText));
        })
            .catch(() => {
            householdPerson.inviteStatus = oldStatus;
            dispatch((0, app_1.appFeedbackMessageError)(errorText));
        });
    };
}
function saveSelectedMemberProfileAndContact(profileData, contactInfoData) {
    return (dispatch, getState) => {
        const successText = 'Profile information has been updated';
        const errorText = 'Failed to update profile information';
        dispatch((0, exports.saveSelectedMemberProfileAndContactStarted)());
        // form validation lives here. We want it to be done after save has been clicked
        // but before the api calls go out.
        const formErrors = (0, validations_common_1.validateProfileFormFields)(profileData, contactInfoData, {
            emailRequired: false,
            birthdateRequired: true,
            isUser: false,
        });
        // if we're showing the save needed model, skip specific form errors and send them back to the working form
        if (!(0, app_2.showSaveNeeded)(getState())) {
            // we have to use deepEmpty here because formErrors has nested objects and we
            // want to check that those are empty
            if (!(0, object_utils_1.isDeepEmpty)(formErrors)) {
                dispatch((0, app_1.appFeedbackMessageError)(errorText));
                throw new redux_form_1.SubmissionError(formErrors);
            }
        }
        const selectedMember = (0, households_1.getSelectedMember)(getState());
        const personId = (0, households_1.selectedMemberPersonId)(getState());
        const oldContact = (0, contact_infos_2.findContactInfo)((0, contact_infos_2.getContactInfos)(getState()), contactInfoData.id);
        const reloadHousehold = oldContact && oldContact.emailAddress !== contactInfoData.emailAddress;
        return api_1.PersonService.updatePerson(personId, profileData)
            .then((data) => {
            // update selected member person
            selectedMember.person = data;
            dispatch((0, exports.setSelectedMember)(selectedMember));
            return dispatch((0, contact_infos_1.submitContactForm)(personId, contactInfoData, false, true)).then(() => {
                if (reloadHousehold) {
                    dispatch(loadHouseholds());
                }
                return dispatch((0, app_1.appFeedbackMessageSuccess)(successText));
            });
        })
            .catch((errorRes) => {
            dispatch((0, app_1.appFeedbackMessageError)(errorText));
            if ((0, app_2.showSaveNeeded)(getState())) {
                const rejectedPromise = new Promise((_resolve, reject) => {
                    // eslint-disable-line no-unused-vars
                    setTimeout(() => {
                        reject('save profile and contact reject Save Needed');
                    }, 1000);
                });
                return rejectedPromise;
            }
            if (errorRes.validationErrors) {
            }
        });
    };
}
function submitCreateMemberForm(householdMember) {
    const successText = 'Household member created';
    const errorText = 'Failed to create household member';
    return (dispatch, getState) => {
        dispatch((0, exports.submitCreateMemberFormStarted)());
        // form validation lives here. We want it to be done after save has been clicked
        // but before the api calls go out
        const formErrors = (0, validations_common_1.validateHouseholdMemberCreateFields)(householdMember);
        if (!(0, lodash_1.isEmpty)(formErrors)) {
            dispatch((0, app_1.appFeedbackMessageError)(errorText));
            throw new redux_form_1.SubmissionError(formErrors);
        }
        const household = (0, lodash_1.find)((0, households_1.getHouseholds)(getState()), (h) => (0, households_1.organizer)(h).uuid === (0, profile_1.currentProfileUuid)(getState()));
        return api_1.HouseholdsService.createHouseholdPerson(household.id, {
            firstName: householdMember.firstName,
            lastName: householdMember.lastName,
            birthdate: householdMember.birthdate,
            gender: householdMember.gender || null,
            emailAddress: householdMember.emailAddress || undefined,
        })
            .then((data) => {
            dispatch((0, exports.setSelectedMember)(data));
            // get the contact infos for this user before we load the member/profile page
            return dispatch((0, contact_infos_1.loadContactInfos)(data.personId)).then(() => {
                return dispatch(loadHouseholds()).then(() => {
                    dispatch((0, app_1.appFeedbackMessageSuccess)(successText));
                    return (0, households_1.getSelectedMember)(getState());
                });
            });
        })
            .catch((error) => {
            if (error.status === 400 && Array.isArray(error.body)) {
                throw new redux_form_1.SubmissionError((0, api_utils_1.formatBadRequestErrors)(error.body));
            }
            dispatch((0, app_1.appFeedbackMessageError)(errorText));
        });
    };
}
// base rejected Promise. This is used for the saveNeeded window. If a save button
// is clicked, it will wait to make sure the submit was successful. If it is not,
// we need to return a rejected promise so the saveNeeded window knows to trigger
// the onSaveError function
